<template>
	<div class="iot-detail pa-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>  
			</div>
		</transition>
		<div class="container">
			<div class="iot-title">
				<h3>{{ langs.iot4 }}{{ langs.iot5 }}</h3>
				<div class="curr-localtion">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">{{ langs.header1 }}</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/iotManage' }">{{ langs.index8 }}</el-breadcrumb-item>
						<el-breadcrumb-item>{{ langs.iot4 }}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<el-row>
				<el-col :xs="24" :md="6" class="iot-box-nav">
					<ul class="iot-nav">
						<li>
							<router-link to="/iotManage/iotdetail1"><span class="iottips ws">{{ langs.index9 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail2"><span class="iottips ws">{{ langs.index11 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail3"><span class="iottips ws">{{ langs.index12 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail4"><span class="iottips ws">{{ langs.iot3 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li class="active">
							<router-link to="/iotManage/iotdetail5"><span class="iottips ws">{{ langs.iot4 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
					</ul>
				</el-col>
				<el-col :xs="24" :md="18" class="iot-box-img">
					<div class="iot-box scroll-container">
						<div class="iot-box-text1 iot-text wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div>{{ langs.iot26 }}</div>
						</div>
						<div class="iot-e iot-e1 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot27 }}</h1>
							<el-image :src="require('../../static/images/iot/e1.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e1.png"></img> -->
						</div>
						<div class="iot-e iot-e2 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot28 }}</h1>
							<el-image :src="require('../../static/images/iot/e2.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e2.png"></img> -->
						</div>
						<div class="iot-e iot-e3 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot29 }}</h1>
							<el-image :src="require('../../static/images/iot/e3.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e3.png"></img> -->
						</div>
						<div class="iot-e iot-e4 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot30 }}</h1>
							<el-image :src="require('../../static/images/iot/e4.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e4.png"></img> -->
						</div>
						<div class="iot-e iot-e5 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot31 }}</h1>
							<el-image :src="require('../../static/images/iot/e5.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e5.png"></img> -->
						</div>
						<div class="iot-e iot-e6 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot32 }}</h1>
							<el-image :src="require('../../static/images/iot/e6.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e6.png"></img> -->
						</div>
						<div class="iot-e iot-e7 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot33 }}</h1>
							<el-image :src="require('../../static/images/iot/e7.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e7.png"></img> -->
						</div>
						<div class="iot-e iot-e8 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot34 }}</h1>
							<el-image :src="require('../../static/images/iot/e8.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e8.png"></img> -->
						</div>
						<div class="iot-e iot-e9 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot35 }}</h1>
							<el-image :src="require('../../static/images/iot/e9.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e9.png"></img> -->
						</div>
						<div class="iot-e iot-e10 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot36 }}</h1>
							<el-image :src="require('../../static/images/iot/e10.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e10.png"></img> -->
						</div>
						<div class="iot-e iot-e11 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot37 }}</h1>
							<el-image :src="require('../../static/images/iot/e11.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e11.png"></img> -->
						</div>
						<div class="iot-e iot-e12 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot38 }}</h1>
							<el-image :src="require('../../static/images/iot/e12.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e12.png"></img> -->
						</div>
						<div class="iot-e iot-e13 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot39 }}</h1>
							<el-image :src="require('../../static/images/iot/e13.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e13.png"></img> -->
						</div>
						<div class="iot-e iot-e14 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot40 }}</h1>
							<el-image :src="require('../../static/images/iot/e14.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/e14.png"></img> -->
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		name: 'iotdetail5',
		data() {
			return {
				showLoading: true,
				
				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh, 
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated） 
					offset: 0,//到元素距离触发动画（当默认为0） 
					mobile: true, //在移动设备上触发动画（默认为true） 
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.iot-title{
		border: 1px solid #eee;
		margin: 15px 0px;
		color: #333;
	}
	.iot-title h3{
		display: inline-block;
		margin: 0px;
		padding: 10px 12px;
		border-left: 3px solid #409EFF;
	}
	.iot-title .curr-localtion{
		float: right;
		margin-top: 15px;
		margin-right: 10px;
	}
	/* iot导航 */
	.iot-nav{
		padding: 0px 15px;
	}
	.iot-nav li{
		cursor: pointer;
		font-size: 18px;
		border-bottom: 1px solid #eee;
	}
	.iot-nav li a{
		display: block;
		padding: 15px 5px 10px;
	}
	.iot-nav li i{
		margin-right: 5px;
	}
	.iot-nav li.active a{
		background-color: #409EFF;
		color: #fff;
	}
	.iot-box{
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 100px;
	}
	.iot-text-tit{
		font-size: 16px;
		color: #409EFF;
	}
	.iot-text >div{
		margin-bottom: 15px;
	}
	.iot-e{
		margin-top: 50px;
	}
	@media screen and (max-width:768px) {
		.iot-title h3{
			display: block;
			border-bottom: 1px solid #eee;
		}
		.iot-title .curr-localtion{
			float: none;
			margin: 8px 15px;
			display: block;
		}
		.iot-box-nav{
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/iotdetail5.vue